import React from 'react';
import { useGenerate } from '../contexts/GenerateContext';
import GenerateHistory from './GenerateHistory';

// This container component isolates the context usage
// to prevent unnecessary re-renders of the GenerateHistory component
const GenerateHistoryContainer = ({ onRegeneratePrompt }) => {
  // This component will re-render when generateHistory changes
  // but will shield the GenerateHistory component from other context changes
  const { generateHistory, removeFromHistory, clearHistory, updateSettings } = useGenerate();
  
  return (
    <GenerateHistory 
      generateHistory={generateHistory}
      removeFromHistory={removeFromHistory}
      clearHistory={clearHistory}
      updateSettings={updateSettings}
      onRegeneratePrompt={onRegeneratePrompt}
    />
  );
};

export default GenerateHistoryContainer;